import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'public/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CoursesIntegrationService {
  refreshDetails = new BehaviorSubject<any>(false);

  constructor(private http: HttpClient) { }

  getAll(params: any): any {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/FilterCourse`, {
      params,
    });
  }

  getCourseDetails(id: number) {
    return this.http.get(
      `${environment.apiUrl}/CourseIntegration/GetCourseDetails?CourseId=${id}`
    );
  }

  getTrainerBioAnonymous(id: string) {
    return this.http.get(
      `${environment.apiUrl}/UserProfile/GetTrainerBioAnonymous?TrainerId=${id}`
    );
  }

  viewContent(id: number) {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/ViewContent?LessonId=${id}`);
  }

  getAllOpenContentLessons(params: any): any {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/GetAllOpenContentLessons`, {
      params,
    });
  }

  getOpenContentDetails(id: number) {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/GetOpenContentDetails?LessonId=${id}`);
  }

  rateContent(model: any): any {
    return this.http.post(`${environment.apiUrl}/CourseIntegration/RateContent`, model);
  }

  countDownloadLesson(model: any): any {
    return this.http.post(`${environment.apiUrl}/CourseIntegration/CountDownloadLesson`, model);
  }

  getCenterKeyHighlight(params: any): any {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/GetCenterKeyHighlight`, { params });
  }

  getListEntityFeaturedCoursePublic(params: any): any {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/ListEntityFeaturedCoursePublic`, { params });
  }

  getAboutUsSectionPublic(params: any): any {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/AboutUsSectionPublic`, { params });
  }

  getTestimonialSectionListsPublic(params: any): any {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/GetTestimonialSectionListsPublic`, { params });
  }

  getListNewsSectionPublic(params: any): any {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/ListNewsSectionPublic`, { params });
  }

  getNewsDetails(id: number): any {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/GetNewsDetails?NewsId=${id}`);
  }

  getListEventsSectionPublic(params: any): any {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/ListEventsSectionPublic`, { params });
  }

  geCenterEventsPublic(params: any): any {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/CenterEventsPublic`, { params });
  }

  getEventDetailsPublic(id: number): any {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/GetEventDetailsPublic?EventsId=${id}`);
  }

  addEventRegisteredTrainee(data: any): any {
    return this.http.post(`${environment.apiUrl}/CourseIntegration/AddEventRegisteredTrainee`, data);
  }

  getVideoSectionPublic(params: any): any {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/VideoSectionPublic`, { params });
  }

  getTopRatedCourses(): any {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/GetTopRatedCourses`);
  }

  getEducationalCenters(): any {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/ListEducationCenters`);
  }

  getPricingPackages(params: any = null): any {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/pricingPackagesList`, { params });
  }

  getPricingPackagesDetails(params: any = null): any {
    return this.http.get(`${environment.apiUrl}/CourseIntegration/pricingPackagesDescription`, { params });
  }
}
